import countries from './Countries'
import races from './CodeRaces'
import religions from './CodeReligions'
import nationalities from './CodeNationalities'
import states from './MYStates'

export default {
   "type": "object",
   "x-display": "expansion-panels",
   "properties": {
      "sectdetails": {
         "type": "object",
         "title": "Personal",
         "description": "",
         "required": [
            "fullname", "dob", "contactemail", "contactmobile", "icpassport"
         ],
         "properties": {
            "fullname": {
               "type": "string",
               "title": "Full Name",
               "default": "",
            },
            "gender": {
               "type": "string",
               "title": "Gender",
               "default": "",
               "oneOf": [
                  {
                     "const": "M",
                     "title": "Male"
                  },
                  {
                     "const": "F",
                     "title": "Female"
                  },
               ]
            },
            "nationality": {
               "type": "string",
               "title": "Nationality",
               "oneOf": nationalities
            },
            "race": {
               "type": "string",
               "title": "Race",
               "default": "",
               "oneOf": races
            },
            "religion": {
               "type": "string",
               "title": "Religion",
               "default": "",
               "oneOf": religions
            },
            "icpassport": {
               "type": "string",
               "title": "IC Number or Passport No.",
               "default": "",
            },
            "dob": {
               "type": "string",
               "title": "Date of Birth",
               "default": "",
               "x-props": {
                  "type": "date"
               }
            },
            "age": {
               "type": "number",
               "title": "Age",
               "default": ""
            },
            "pob": {
               "type": "string",
               "title": "Place of Birth",
               "default": "",
            },
            "contactmobile": {
               "type": "string",
               "title": "Mobile Number",
               "default": "",
               "minLength": 8,
               "pattern": "^[0-9+() .-]+$",
               "x-props": {
                  "hint": "Required. Use your active mobile number.",
                  "persistent-hint": true
               }
            },
            "contactemail": {
               "type": "string",
               "title": "Personal Email",
               "default": "",
            },
         }
      },
      "secthome": {
         "type": "object",
         "title": "Home Address",
         "description": "",
         "required": [
            "homestate"
         ],
         "properties": {
            "homestreet": {
               "type": "string",
               "title": "Street",
               "default": "-"
            },
            "homepostcode": {
               "type": "string",
               "title": "Postcode",
               "default": "-"
            },
            "homecity": {
               "type": "string",
               "title": "PBT",
               "default": "-"
            },
            "homedistrict": {
               "type": "string",
               "title": "District",
               "default": "-"
            },
            "homestate": {
               "type": "string",
               "title": "State / Zone",
               "default": "",
               "oneOf": states.map(state => ({
                  "const": state.const,
                  "title": state.title
               })),
               "x-props": {
                  "clearable": true
               }
            },
            "homecountry": {
               "type": "string",
               "title": "Country",
               "default": "MY",
               "oneOf": countries
            },
            "homephone": {
               "type": "string",
               "title": "Phone @ Home",
               "default": "-"
            },
         },
      },
      "sectwork": {
         "type": "object",
         "title": "Practice",
         "description": "",
         "required": [

         ],
         "properties": {
            "workcompany": {
               "type": "string",
               "title": "Name of Organization/Company/Practice",
               "default": "-"
            },
            "workjobtitle": {
               "type": "string",
               "title": "Job Title",
               "default": "-"
            },
            "workdept": {
               "type": "string",
               "title": "Department",
               "default": "-"
            },
            "workposition": {
               "type": "string",
               "title": "Position/Grade",
               "default": "-"
            },
            "workstreet": {
               "type": "string",
               "title": "Business/Office Address",
               "default": "-"
            },
            "workpostcode": {
               "type": "string",
               "title": "Postcode",
               "default": "-"
            },
            "workcity": {
               "type": "string",
               "title": "PBT",
               "default": "-"
            },
            "workdistrict": {
               "type": "string",
               "title": "District",
               "default": "-"
            },
            "workstate": {
               "type": "string",
               "title": "State",
               "default": ""
            },
            "workcountry": {
               "type": "string",
               "title": "Country",
               "default": "MY",
               "oneOf": countries
            },
            "workphone": {
               "type": "string",
               "title": "Phone @ Work",
               "default": "-"
            },
            "workfax": {
               "type": "string",
               "title": "Fax @ Work",
               "default": "-"
            },
            "workemail": {
               "type": "string",
               "title": "Email @ Work",
               "default": "-"
            },
         },
      },
      "sectcontactpref": {
         "type": "object",
         "title": "Contact Method",
         "description": "Preferred contact method",
         "properties": {
            "prefercontacthome": {
               "type": "boolean",
               "title": "Home Address",
               "default": ""
            },
            "prefercontactwork": {
               "type": "boolean",
               "title": "Business Address",
               "default": ""
            },
            "prefercontactemail": {
               "type": "boolean",
               "title": "Email",
               "default": ""
            }
         }
      }
   }
}
